import { APP_NAME } from "@/config";
import { useEffect } from "react";

const useDocumentTitle = (title: string) => {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = `${title} | ${APP_NAME}`;

    return () => {
      document.title = prevTitle; // cleanup (optional)
    };
  }, [title]);
};

export default useDocumentTitle;
